import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { AsyncNotificationStatus } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { DataHook, Truncated } from './components';
import styles from './components/Truncated/Truncated.scss';
import { GenericNotification } from './GenericNotification';

export const pasteCopiedFilesNotification =
  ({ items, sourceName, targetName, onSourceClick, onTargetClick }) =>
  ({ notification }) =>
    (
      <DataHook dataHook="notification.copy-paste" notification={notification}>
        <GenericNotification
          notification={notification}
          text={
            <FormattedMessage
              id={
                notification.status === AsyncNotificationStatus.Pending
                  ? 'files-manager.paste-copied-files-notification.pending'
                  : 'files-manager.paste-copied-files-notification.done'
              }
              values={{
                itemsCount: items.length,
                itemName: <Truncated>{items[0].name}</Truncated>,
                sourceName: (
                  <TextButton
                    className={styles.truncated}
                    as="a"
                    size="small"
                    underline="always"
                    onClick={onSourceClick}
                    skin="dark"
                    dataHook="notification-link"
                  >
                    {sourceName}
                  </TextButton>
                ),
                targetName: (
                  <TextButton
                    className={styles.truncated}
                    as="a"
                    size="small"
                    underline="always"
                    onClick={onTargetClick}
                    skin="dark"
                    dataHook="notification-link"
                  >
                    {targetName}
                  </TextButton>
                ),
              }}
            />
          }
        />
      </DataHook>
    );
